module.exports = __webpack_public_path__ + "static/media/Screenshot_MapB_1.ce592f37.jpg";